
// import { interceptMap } from '@admin/router/insetIntercept.js';

import {
  inIframe,
  parentRouteSame,
  addEventListenerMessage,
} from './utils';
import MyModal from './Modal/index.vue';
// 初始化iframe 微应用改造
export async function initMicroApp({
  router,
  Vue,
  // store
}) {
  if (!inIframe || initMicroApp.isInit) {
    return;
  }
  initMicroApp.isInit = true;
  addEventListenerMessage({
    router,
    // store
  });
  router.beforeEach(async (to, from, next) => {
    parentRouteSame({ to, from });
    next();
  });
  // 重写Modal样式
  // Vue.component('Modal', ()=>import('@/components/Modal/index.vue'));
  Vue.component('Modal', MyModal);
};
